export default __webpack_public_path__ + "b7ca91c53c355c725f4dfd60b4bbb7eb.webp";